import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'keys',
  standalone: true,
  pure: false
})
export class KeysPipe implements PipeTransform {
  transform(value: any): any {
    return Object.keys(value).map(k => ({key: k, value: k}))
  }
}
